import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Context from "../../../Context";
import { HTRequestItem, HTRoleType, HTSearchRequest, HTSearchResponse } from "../../../api/entities";
import { hideLoading, showErrorMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { verifyTenantUserProfile } from "@eres/ejari-web/component/TenantContract/PropertyDetails";
import { getRequests, validateResponse } from "../../../api/api";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import RequestsListView from "../../components/requests/RequestsListView";
import RequestsGridView from "../../components/requests/RequestsGridView";
import { getParticipantID } from "@10x/sso";
import { showRequestDetails } from "../../../NavigationUtils";
import { resetData } from "../../../Utils";
import { HTRequestsBCItem, MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";

interface Props extends RoutedViewProps<{ roleId: string }> {

}

interface State {
	isLoading: boolean;
	tenantId: number;
	requests: HTRequestItem[];
	roleId: number;
}

class RequestList extends Component<Props, State> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;

	constructor( props: Props ) {
		super( props );
		const { roleId } = this.props.match.params;
		this.state = {
			isLoading: true,
			tenantId: 0,
			requests: [],
			roleId: Number( roleId ),
		};
	}

	componentDidMount() {
		if ( this.state.roleId === HTRoleType.TENANT ) {
			this.verifyTenantProfile();
		} else {
			this.loadRequests();
		}
	}

	render() {
		const { isLoading, requests, roleId } = this.state;
		const title = ( roleId === HTRoleType.OWNER ) ? Strings.my_requests : Strings.requests_from_owner;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ requests && requests.length > 0 }
			title={ title }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }>
			<PageTitle title={ title } paths={ [ MyRequestsBCItem, HTRequestsBCItem ] }/>
		</ListGridDataView>;
	}

	private renderListView = () => {
		const { requests } = this.state;
		return <RequestsListView
			requests={ requests || [] }
			onDetails={ this.onDetails }/>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <RequestsGridView
			requests={ requests || [] }
			onDetails={ this.onDetails }/>;
	};

	private verifyTenantProfile() {
		verifyTenantUserProfile().then( ( tenantId: number | undefined ) => {
			if ( tenantId && tenantId !== 0 ) {
				this.setState( { tenantId: tenantId }, () => {
					this.loadRequests();
				} );
			} else {
				this.handleResponse();
				showErrorMessage( Strings.tenant_verify_error );
			}
		} ).catch( e => {
			this.handleResponse();
			showErrorMessage( e );
		} );
	}

	private loadRequests() {
		const { roleId, tenantId } = this.state;
		const req: HTSearchRequest = {
			PageIndex: 0,
			PageSize: 100,
		} as HTSearchRequest;
		if ( roleId === HTRoleType.OWNER ) {
			req.RoleId = HTRoleType.OWNER;
			req.ParticipantId = getParticipantID();
		} else {
			req.RoleId = HTRoleType.TENANT;
			req.TenantId = tenantId;
		}
		getRequests( req ).then( validateResponse ).then( response => {
			this.handleResponse( response );
		} ).catch( e => {
			this.handleResponse();
			showErrorMessage( e );
		} );
	}

	private handleResponse( response?: HTSearchResponse ) {
		const requests: HTRequestItem[] = ( response ? response.Data : [] );
		hideLoading();
		this.setState( {
			isLoading: false,
			requests: requests,
		} );
	}

	private onDetails = ( request: HTRequestItem ) => {
		const { roleId } = this.state;
		resetData();
		showRequestDetails( roleId, request.RequestTypeId, request.RequestNumber );
	};
}

export default RequestList;
